import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    overflow: 'hidden',
    padding: '32px',
    borderRadius: '16px',
    boxShadow: '3',
    // maxHeight: '304px',
    minHeight: '304px',
  },
  contentWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  imageWrapper: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '1rem',
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
    maxHeight: '240px',
    maxWidth: '393px',
    borderRadius: '8px',
    display: { xs: 'none', md: 'block' },
  },

  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
  },
  chip: {
    borderRadius: '4px',
    padding: '12px 0px !important',
    ':hover': {
      backgroundColor: 'orange.500',
      color: 'common.white',
    },
    border: '1px solid',
    borderColor: `border.light`,
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
